import DisassociateIcon from 'assets/icons/DIsassociate'
import React, { FC } from 'react'
import { ContainerButtons, ModalBody, ModalContainer, LargeText, Title } from './styled'
import { DangerButton, GhostButton, SecondaryButton } from 'views/components/UI/Buttons'
import Modal from 'views/components/UI/Modal'
import RollBackIcon from 'assets/icons/RollBackIcon'

interface SuspendAdminPlatformModalProps {
  isClosed: boolean
  setIsClosed: (value: boolean) => void
  handleCloseClick: () => void
  isSuspendAction?: boolean
  handleButtonActionClick?: () => void
  idStatus?: number
}

const SuspendAdminPlatformModal: FC<SuspendAdminPlatformModalProps> = ({
  isClosed,
  setIsClosed,
  handleCloseClick,
  isSuspendAction,
  handleButtonActionClick = () => {},
  idStatus,
}) => {
  return (
    <Modal
      show={!isClosed}
      setShow={setIsClosed}
      hideCloseButton={true}
      styleContent={{
        width: '50%',
        height: 'auto',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
      }}
    >
      {isSuspendAction ? (
        <>
          <ModalContainer>
            <ModalBody>
              <DisassociateIcon width="82px" height="82px" />
              <Title> ¿Seguro que deseas suspender a este usuario?</Title>
              <LargeText>
                Si suspendes a este usuario no podrá ingresar a su cuenta de Bluesite. Podrás reactivarlo en cualquier
                momento y su información no se perderá.
              </LargeText>
            </ModalBody>
            <ContainerButtons>
              <GhostButton type="button" onClick={handleCloseClick}>
                Cancelar
              </GhostButton>
              <DangerButton
                type="submit"
                leadingIcon={<DisassociateIcon color="#FFFFFF" />}
                onClick={handleButtonActionClick}
              >
                Suspender
              </DangerButton>
            </ContainerButtons>
          </ModalContainer>
        </>
      ) : idStatus === 3 ? (
        <>
          <ModalContainer>
            <ModalBody>
              <Title> ¿Seguro que deseas eliminar a este usuario?</Title>
              <LargeText>El usuario deberá volverse a registrar.</LargeText>
            </ModalBody>
            <ContainerButtons>
              <GhostButton type="button" onClick={handleCloseClick}>
                Cancelar
              </GhostButton>
              <DangerButton
                type="submit"
                leadingIcon={<RollBackIcon color="#FFFFFF" />}
                onClick={handleButtonActionClick}
              >
                Eliminar
              </DangerButton>
            </ContainerButtons>
          </ModalContainer>
        </>
      ) : (
        <>
          <ModalContainer>
            <ModalBody>
              <RollBackIcon width="82px" height="82px" />
              <Title> ¿Seguro que deseas reactivar a este usuario?</Title>
              <LargeText>El usuario podrá acceder nuevamente a su cuenta de Bluesite.</LargeText>
            </ModalBody>
            <ContainerButtons>
              <GhostButton type="button" onClick={handleCloseClick}>
                Cancelar
              </GhostButton>
              <SecondaryButton
                type="submit"
                leadingIcon={<RollBackIcon color="#2D749C" />}
                onClick={handleButtonActionClick}
              >
                Reactivar
              </SecondaryButton>
            </ContainerButtons>
          </ModalContainer>
        </>
      )}
    </Modal>
  )
}

export default SuspendAdminPlatformModal
